export const primaryBackground = 'rgb(255, 255, 255)'

export const secondaryColor = 'rgba(255, 255, 255, 0)'
export const primaryColor = 'rgb(82, 82, 82)'
